import { useCallback, useEffect, useState } from 'react';
import { locationVerificationDraftStorage } from '@/store/idbStorage/locationVerificationDraftStorage';
import { LocationVerificationDraft } from '@/types/LocationVerification.type';

export function useLocationVerificationDraft(inspectionId: string | undefined): {
  draft: LocationVerificationDraft | null;
  isLoading: boolean;
  refreshDraft: () => Promise<void>;
} {
  const [draft, setDraft] = useState<LocationVerificationDraft | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const refreshDraft = useCallback(async () => {
    if (!inspectionId) {
      setDraft(null);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const nextDraft = await locationVerificationDraftStorage.get(inspectionId);
    setDraft(nextDraft);
    setIsLoading(false);
  }, [inspectionId]);

  useEffect(() => {
    void refreshDraft();
  }, [refreshDraft]);

  return { draft, isLoading, refreshDraft };
}
